<template>
  <div style="background:#fff;height:100%">
    <section class="app-section" id="pendingOrders">
      <div class="flex">
        <div class="sectionfl">
          <h6>
            问卷分类
            <!-- <Button @click="append()"
                    type="text"
            style="font-size: 26px; color:#A09999; float: right; ">+</Button>-->
          </h6>
          <div class="tip">
            <i class="el-icon-warning" style="margin-right:5px"></i>一级分类不可新建问卷，请先在对应业务下创建二级分类
          </div>
          <div style="flex:1;overflow: auto">
            <el-tree
              ref="viewTree"
              :data="typeLists"
              node-key="id"
              :props="defaultProps"
              :highlight-current="showTree"
              @node-click="handleNodeClick"
              :expand-on-click-node="false"
              :default-expanded-keys="defaultExpanded"
              :default-checked-keys="defaultChecked"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{data.text}}</span>
                <i>
                  <el-popover placement="right-end" width="40" trigger="hover">
                    <div>
                      <div class="hovers" v-if="data.level != '1'">
                        <el-button
                          type="text"
                          size="mini"
                          style="color:#738299"
                          @click.stop="() => modifyEdit(node,data)"
                        >
                          <i style="padding-right:6px" class="el-icon-edit-outline"></i>编辑分类
                        </el-button>
                      </div>
                      <div class="hovers" v-if="data.level != '1'">
                        <el-button
                          type="text"
                          style=" color: #738299"
                          size="mini"
                          @click.stop="() => remove( data)"
                        >
                          <i style="padding-right:6px" class="el-icon-delete"></i>删除分类
                        </el-button>
                      </div>
                      <div class="hovers">
                        <el-button
                          type="text"
                          style=" color: #738299"
                          size="mini"
                          @click.stop="() => append( data)"
                        >
                          <i style="padding-right:6px" class="el-icon-plus"></i>新增分类
                        </el-button>
                      </div>
                    </div>

                    <i
                      slot="reference"
                      style="transform:rotate(90deg);color:#999"
                      class="el-icon-more"
                    ></i>
                    <!-- <i >激活</i> -->
                  </el-popover>
                </i>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="sectionfr">
          <div v-show="flag" style="display:flex;margin: 20px 0; ">
             <div style="flex: 1;">
                <el-input
                  v-model="questionnaireName"
                  placeholder="请输入问卷名称搜索"
                  style="max-width: 350px"
                  @keyup.enter.native="getQuesList"
                />
                <Button
                  type="primary"
                  shape="circle"
                  @click="getQuesList()"
                  style="margin-left:10px"
                >搜索</Button>
            </div>
            <Button type="primary" shape="circle" @click="addDropaganda()">新增问卷</Button>
            <Button
              type="primary"
              shape="circle"
              @click="copyQues()"
              style="margin-left:10px"
            >从模板库新建</Button>
          </div>

          <Card style="margin-top:20px;position:relative;">
            <Table :columns="columns" :data="list" :loading="!haveData">
              <template slot-scope="{row, index}" slot="action">
                <div>
                  <el-button
                    type="text"
                    style="margin-right: 10px"
                    @click="moveToDetail(row,index)"
                  >详情</el-button>
                  <el-button
                    type="text"
                    class="error"
                    style="margin-left: 0"
                    @click="removeQuesType(row)"
                  >删除</el-button>
                  <!-- <el-popconfirm title="确定删除这一模块吗？" @confirm="deleteModule(row)">
                    <el-button slot="reference" type="text" class="error">删除</el-button>
                  </el-popconfirm>-->
                  <!-- <el-button type="text" style="margin-left: 10px" @click="addBusiness(row)">新增</el-button> -->
                </div>
              </template>
            </Table>
          </Card>
          <Page :total="total" class="pageBox" @on-change="changeIndex" show-total />
        </div>
      </div>
    </section>

    <Modal v-model="dialogFormVisible" draggable footer-hide :title="fileNmae" :z-index="999">
      <div :style="{'max-height': (windowHeight - 100 * 2 - 150) + 'px'}">
        <Form ref="form" :model="form" :rules="formRules" :label-width="100">
          <FormItem label="分类名称" prop="type_name">
            <Input
              v-model.trim="form.type_name"
              :maxlength="10"
              style="width:260px"
              placeholder="请输入分类名称"
            ></Input>
          </FormItem>
          <FormItem label="可见范围" prop="VisibleValue">
            <Select
              v-model="form.VisibleValue"
              clearable
              @on-change="setdiseaseList"
              style="width:260px"
            >
              <Option
                v-for="item in Visible"
                :disabled="item.disabled"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="选择病种" v-if="showDiseaseList" prop="iseaseList">
            <Select v-model="form.iseaseList" multiple style="width:260px">
              <Option
                v-for="item in disease_tree_responses"
                :value="item.disease_id"
                :key="item.disease_id"
              >{{ item.disease_name }}</Option>
            </Select>
          </FormItem>
        </Form>
        <div style="text-align:center;margin-top:16px;">
          <Button @click="cancel()">取消</Button>
          <Button type="primary" style="margin-left:20px" @click="submit()">保存</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="copyVisible" width="80%" footer-hide title :z-index="999">
      <div :style="{'max-height': (windowHeight - 100 * 2 ) + 'px'}"></div>
      <Tabs :value="tabValue" :animated="false" @on-click="onTabClick">
        <TabPane
          type="border-card"
          v-for="(i, index) in queryList"
          :key="'tab_' + index"
          :label="i.name"
          :name="i.name"
        ></TabPane>
        <div style="position:relative;margin-top:16px;">
          <chooseQues
            :style="{'max-height': (windowHeight - 100 * 3 ) + 'px'}"
            style="overflow-y: auto;"
            :info="hosInfo"
            @selectionData="selectionData"
          ></chooseQues>
          <div style="text-align:center;margin-top:16px;">
            <Button @click="cancelMini()">取消</Button>
            <Button type="primary" style="margin-left:20px" @click="submitMini()">保存</Button>
          </div>
        </div>
      </Tabs>
    </Modal>
  </div>
</template>

<script>
import $ from 'jquery'
import route from '../../route/config'
import chooseQues from '../common/chooseQuesCopy'
import { getTab, copyQues } from '../../api/questionaire'
export default {
  data() {
    return {
      fileNmae: '新增分类',
      typeLists: [],
      dialogFormVisible: false,
      typeName: '',
      typeCode: '',
      form: {
        type_name: '',
        iseaseList: '',
        VisibleValue: '',
      },
      Visible: [
        {
          value: '0',
          label: '个人可见',
          disabled: false,
        },
        {
          value: '1',
          label: '病种可见',
          disabled: false,
        },
      ],
      formRules: {
        type_name: [{ required: true, message: '请输入分类名称' }],
        VisibleValue: [
          { required: true, message: '请选择可见范围', trigger: 'blur' },
        ],
        iseaseList: [
          { required: true, message: '请选择病种', trigger: 'blur' },
        ],
      },
      typeRules: {
        name: [{ required: true, message: '请选择分类', trigger: 'blur' }],
      },
      columns: [
        {
          title: '问卷名称',
          key: 'questionnaire_name',
          align: 'center',
        },
        {
          title: '创建时间',
          key: 'created_time',
          align: 'center',
        },

        {
          title: '操作',
          key: 'action',
          minWidth: 60,
          slot: 'action',
          align: 'center',
        },
      ],
      showTree: true,
      defaultProps: {
        children: 'children',
        label: 'text',
      },
      list: [],
      haveData: false,
      total: 0,
      current: 1,
      size: 10,
      sizes: [20, 30, 40, 50],
      quesInfo: {},
      index_page: 0,
      disease_tree_responses: [],
      showDiseaseList: false,
      SelectData: {},
      creatData: {},
      flag: false,
      copyVisible: false,
      queryList: [],
      hosInfo: {},
      select: [],
      tabValue: '',
      defaultExpanded: [],
      defaultChecked: [],
      questionnaireName:''
    }
  },
  components: {
    chooseQues,
  },

  computed: {
    refreshQues: function () {
      return this.$store.state.refreshQues
    },
    windowHeight: function () {
      return window.innerHeight
    },
  },
  methods: {
    changeIndex(e) {
      this.index_page = e
      this.getQuesList()
    },

    setdiseaseList(val) {
      console.log(this.disease_tree_responses)
      console.log(val, this.disease_tree_responses.length != 0)
      if (val == '1' && this.disease_tree_responses.length != 0) {
        this.showDiseaseList = true
      } else {
        this.showDiseaseList = false
      }
    },
    handleNodeClick(data, e) {
      console.log(data)
      if (data.level == 1) {
        this.flag = false
      } else {
        this.flag = true
      }
      this.creatData = data
      this.typeCode = data.id
      this.typeName = data.text

      this.index_page = 1
      this.questionnaireName = ''
      this.getQuesList()
    },
    column: function (id, index) {
      this.index_page = index
      this.typeCode = id

      this.getQuesList()
    },
    cancel: function () {
      this.dialogFormVisible = false
      this.typeName = ''
      this.typeCode = ''
    },
    modifyEdit: function (node, data) {
      console.log(node, data)
      this.form.VisibleValue = ''
      this.disease_tree_responses = []
      let diseaseList = this.$store.getters.curDiseaseList
      if (node.parent.data.level == 1) {
        this.disease_tree_responses = diseaseList
      } else {
        this.disease_tree_responses = node.parent.data.disease_tree_responses
      }

      if (data.disease_tree_responses.length) {
        this.form.VisibleValue = '1'
        this.showDiseaseList = true
      } else {
        this.form.VisibleValue = '0'
        this.showDiseaseList = false
      }

      let arr = []
      data.disease_tree_responses.forEach((res) => {
        arr.push(res.disease_id)
      })
      this.form.iseaseList = arr
      this.dialogFormVisible = !this.dialogFormVisible
      this.form.type_name = data.text

      this.fileNmae = '编辑问卷分类'
      this.SelectData = data
    },
    append(data) {
      this.form.iseaseList = []
      let shift = this.$store.state.shift

      this.form.iseaseList.push(shift.disease_id)
      this.form.VisibleValue = ''
      this.form.type_name = ''
      this.ResetList(data)
      this.dialogFormVisible = !this.dialogFormVisible
      this.fileNmae = '新增问卷分类'
      this.SelectData = data
    },
    ResetList(data) {
      let diseaseList = this.$store.getters.curDiseaseList
      this.Visible[1].disabled = false
      if (data.level == 1) {
        if (
          data.disease_tree_responses == null ||
          data.disease_tree_responses.length == 0
        ) {
          this.disease_tree_responses = diseaseList
        } else {
          this.disease_tree_responses = data.disease_tree_responses
        }
      } else if (
        data.level != 1 &&
        data.user_id == 0 &&
        data.user_id !== null
      ) {
        this.disease_tree_responses = data.disease_tree_responses
      } else {
        this.disease_tree_responses = []
        this.Visible[1].disabled = true
      }
    },
    submit: function () {
      let url = this.$utils.getInterface('QUES_CATEGORY'),
        query

      if (!this.form.type_name) {
        this.$Message.warning('请选择分类名称')
        return
      }
      if (!this.form.VisibleValue) {
        this.$Message.warning('请选择可见范围')
        return
      }
      if (this.form.VisibleValue == '0') {
        query = {
          disease_id: this.$store.state.shift.dept_id,
          category_name: this.form.type_name,
          level: this.SelectData.level + 1,
          parent_id: this.SelectData.id,
          permission_type: this.form.VisibleValue,
        }
      } else {
        query = {
          disease_id: this.$store.state.shift.dept_id,
          category_name: this.form.type_name,
          level: this.SelectData.level + 1,
          parent_id: this.SelectData.id,
          permission_type: this.form.VisibleValue,
          disease_ids: this.form.iseaseList,
        }
      }
      if (this.fileNmae == '编辑问卷分类') {
        url = this.$utils.getInterface('QUES_CATEGORY') + '/edit'
        query.id = this.SelectData.id
      }

      //       url = this.$utils.getInterface('QUES_CATEGORY')
      this.$utils.caringRequest({
        method: 'POST',
        url: url,
        data: query,
        success: (res) => {
          if (res.code == 0) {
            this.getTypeGroup()
            this.dialogFormVisible = !this.dialogFormVisible
            this.form.iseaseList = []
            this.form.VisibleValue = ''
            this.form.type_name = ''
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    remove: function (data) {
      console.log(data)
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认删除该分类?',
        onOk: () => {
          self.fileNmae = '删除问卷分类'
          self.typeName = data.name
          self.typeCode = data.id
          self.form.type_name = data.name

          self.$utils.caringRequest({
            method: 'POST',
            url:
              self.$utils.getInterface('QUES_CATEGORY') + '/remove/' + data.id,

            success: (res) => {
              if (res.code == 0) {
                self.getTypeGroup()
                // this.dialogFormVisible = !this.dialogFormVisible
                // this.form.iseaseList = []
                // this.form.VisibleValue = ''
                // this.form.type_name = ''
              } else {
                self.$Message.error(res.message)
              }
              // if (res.code === 0) {
              //   self.getTypeGroup()
              //   if (self.fileNmae != '删除问卷分类') {
              //     self.dialogFormVisible = !self.dialogFormVisible
              //   }
              //   self.typeName = ''
              //   self.typeCode = ''
              //   self.$Message.success(res.message)
              //   self.index_page = 0
              // } else {
              //   self.$Message.error(res.message)
              // }
            },
          })
        },
      })
    },
    removeQuesType(row) {
      let self = this
      console.log(row)
      self.$Modal.confirm({
        title: '提示',
        content: '删除操作不可恢复，请谨慎操作！',
        onOk: () => {
          this.$utils.caringRequest({
            method: 'DELETE',
            url:
              this.$utils.getInterface('QUES_ADD_NEW') +
              '/id?question_id=' +
              row.questionnaire_id,
            success: (res) => {
              if (res.code == 0) {
                this.getQuesList()
              } else {
                this.$Message.error(res.message)
              }
            },
          })
        },
      })
    },
    getTypeGroup: function () {
      // console.log(347, this.$store.state.shift)
      let shift = this.$store.state.shift
      var self = this
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUES_CATEGORY'),
        data: {
          disease_id: shift.disease_id,
          dept_id: shift.dept_id,
        },

        success: function (res) {
          if (res.code === 0) {
            self.haveData = true
            self.typeLists = res.data
            // self.typeCode = res.data[0].id
            self.typeName = res.data[0].text
            self.index_page = 0
            self.typeCode = res.data[0].children[0].id
            self.handleNodeClick(res.data[0].children[0])
            self.defaultExpanded.push(res.data[0].id)
            self.defaultChecked.push(res.data[0].children[0].id)
            self.$nextTick(function () {
              self.$refs.viewTree.setCurrentKey(res.data[0].children[0].id)
            })
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },

    getQuesList: function () {
      var self = this
      self.haveData = false
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUES_NEWS'),
        data: {
          category_id: self.typeCode,
          page: self.index_page,
          size: 10,
          name:self.questionnaireName
        },

        success: function (res, response) {
          self.haveData = true
          self.total = Number(response['x-total-count']) || 0
          if (res.code === 0) {
            self.list = res.data
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    addDropaganda: function () {
      let type = {
        typeCode: this.typeCode,
        typeName: this.typeName,
      }
      console.log(type)

      localStorage.setItem('typeInfo', JSON.stringify(type))

      this.$store.state.dataConfig = []
      this.$store.state.modules = []
      this.$store.state.moduleChoosed = -1
      ;(this.$store.state.quesInfo = {}),
        (this.$store.state.quesInfoIndex = -1),
        (this.$store.state.quesName = ''),
        (this.$store.state.quesDesc = ''),
        (this.$store.state.maxInnerId = 0),
        (this.$store.state.questionnaireAttribute = {
          // 问卷名称
          name: '',
          // 问卷提示信息
          prompt: '',
          // 填写者权限
          userPermission: 'all',
          // 频率
          frequency: 'all',
          // 密码
          password: '',
          // 二维码
          showQRCode: false,
          // 业务名称
          businessName: '',
          // 是否需要验证码
          needVerificationCodeWhenSubmit: false,
          // 登陆用户填完后可修改
          modifyWhenLogin: false,
          // 最大条数限制 整型数值
          maxRecordQuantity: 0,
          // 每天固定时间开启
          openAtFixedTime: false,
          // 是否开启时间
          hasStartEndDate: false,
          // 开始日期
          startDate: '',
          // 结束日期
          endDate: '',
          // 开启时间
          startAndEndTimes: [{ startTime: '', endTime: '' }],
          // 分值段说明
          scoreSegments: [{ startScore: '', endScore: '', description: '' }],
        }),
        this.$store.commit('setSource', 'create')
      localStorage.setItem('source', 'create')

      let self = this
      self.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'addQues',
        title: '新增问卷',
        key: 'addQues',
        extra: {
          typeId: self.typeCode,
        },
      })
    },
    moveToDetail(row) {
      let _this = this
      _this.$store.commit('clearDataConfig')
      _this.$store.state.quesInfo = {}
      _this.$store.state.quesInfoIndex = -1
      $.ajax({
        type: 'GET',
        url:
          _this.$store.state.INTERFACE.QUESTIONNAIRE +
          '/' +
          row.questionnaire_id,
        cache: false,
        contentType: 'application/json',
        headers: {
          tenant: _this.$store.state.tenant.tenant,
        },
        success: function (res) {
          if (res.code == '0') {
            let moduleLength = res.data.questions.length

            let id =
              res.data.questions[moduleLength - 1].value.innerOrder.split(
                '_'
              )[1] || 0
            _this.$store.commit('setInnerId', id)
            _this.$store.state.questionnaireAttribute =
              res.data.questionnaire.questionnaireAttribute
            //  console.log(res.data.moduleResponse)
            res.data.moduleResponse.modules.forEach((item, index) => {
              item.type = 'module'
              item.questionList.forEach((info, _index) => {
                res.data.questions.forEach((ques, __index) => {
                  if (info.value.innerOrder == ques.value.innerOrder) {
                    info.value.id = ques.value.id
                    info.value.questionnaireId = ques.value.questionnaireId
                  }
                })
              })
            })

            _this.$store.state.dataConfig = res.data.moduleResponse.modules

            res.data.questions.forEach((item, index) => {
              if (item.value.innerOrder === '') {
                _this.$store.state.dataConfig.push(item)
              }

              if (item.type == 'DigitalQuestion') {
                if (!item.value.digitalAttribute.hasOwnProperty('outliers')) {
                  let arr = [
                    {
                      min: '',
                      max: '',
                      isNormalUrl: false,
                      normalUrl: '',
                      isNotNormalUrl: false,
                      notNormalUrl: '',
                    },
                  ]
                  _this.$set(item.value.digitalAttribute, 'outliers', arr)
                }
              }
            })

            _this.$store.state.dataConfig = _this.$store.state.dataConfig.sort(
              _this.compare('realIndex')
            )

            _this.$store.state.quesName =
              res.data.questionnaire.questionnaireAttribute.name
            _this.$store.state.quesDesc =
              res.data.questionnaire.questionnaireAttribute.prompt

            _this.$store.commit('setSource', 'edit')
            _this.$store.commit('changeQuestId', row.questionnaire_id)

            _this.$store.commit('setAllSelectedKeys', {
                type: 'delete',               
                key: 'addQues',
              })

            _this.$store.commit('setAllSelectedKeys', {
              type: 'add',
              name: 'addQues',
              title: route['addQues'].title,
              // key: `addQues?${row.questionnaire_id}`,
              key: 'addQues',
              extra: {
                id: row.questionnaire_id,
              },
            })
          } else {
            _this.$Message.error(res.message)
          }
        },
        error: function () {
          Message.error({
            message: '网络异常，请稍后再试',
          })
        },
      })
    },
    compare: function (realIndex) {
      return function (obj1, obj2) {
        var value1 = obj1[realIndex]
        var value2 = obj2[realIndex]
        return value1 - value2
      }
    },
    analysis: function (row) {
      console.log(row)
      let group = []
      group[0] = row.type_id
      group[1] = row.id
      this.$store.commit('setGroupId', group)

      // this.$utils.openPage({
      //   type: 'filterAnalysis',
      //   title: '筛查分析',
      //   id: 0,
      //   params: {
      //     id: row.questionnaire_id,
      //   },
      // })
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'filterAnalysis',
        title: route['filterAnalysis'].title,
        key: `filterAnalysis?${row.questionnaire_id}`,
        extra: {
          id: row.questionnaire_id,
        },
      })
    },
    copyQues: function () {
      this.getTab()
      this.copyVisible = true
    },
    getTab: function () {
      let param = {
        // is_team: 1,
      }
      getTab(param).then((res) => {
        if (res.code === 0) {
          this.queryList = res.data
          // console.log(this.queryList)
          if (res.data.length > 0) {
            this.tabValue = this.queryList[0].name
            this.onTabClick(res.data[0].name)
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    onTabClick: function (name) {
      console.log(name)
      this.tabValue = name
      this.queryList.forEach((v) => {
        if (v.name == name) {
          this.hosInfo = v
        }
      })
    },
    cancelMini: function () {
      this.copyVisible = false
    },
    submitMini: function () {
      if (this.select.length == 0) {
        this.$Message.warning('请选择问卷')
        return
      }
      console.log(this.select)
      let questionnaire_request_list = []
      this.select.forEach((v) => {
        let obj = {}
        obj.category_id = this.typeCode
        obj.questionnaire_id = v.questionnaire_id
        obj.questionnaire_name = v.questionnaire_name
        questionnaire_request_list.push(obj)
      })
      console.log(questionnaire_request_list)

      let obj = {
        tab_id: this.hosInfo.id,
        questionnaire_request_list: questionnaire_request_list,
      }

      copyQues(obj).then((res) => {
        if (res.code === 0) {
          this.copyVisible = false
          this.getQuesList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    selectionData: function (data) {
      this.select = data
    },
  },
  mounted() {
    this.getTypeGroup()
    // this.getTab()
  },
  watch: {
    refreshQues: function () {
      this.getQuesList()
    },
  },
}
</script>

<style lang="less" >
@import '../../styles/common.less';
.hovers:hover {
  background-color: #e6efff;
}
* {
  font-size: 15px;
}

#pendingOrders {
  .flex {
    background: #fff;
    display: flex;
    height: 100%;
    .sectionfl {
      margin: 20px;
      background: #fff;
      width: 320px;
      border: 1px solid #dee3ee;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      .content {
        width: 320px;
        color: #666;
        height: 54px;
        line-height: 54px;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
        cursor: pointer;
        font-size: 15px;
      }
      h6 {
        width: 318px;
        background: #f6f8fc;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-weight: normal;
        font-size: 14px;
        // border-bottom: 1px solid #dee3ee;
      }

      .content.active {
        color: #409eff;
      }
    }
    .sectionfr {
      flex: 1;
      position: relative;
      overflow-y: auto;
      padding-right: 30px;
      background: #fff;
    }
  }
  h6 {
    color: #606266;
  }
  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  .bg {
    background: #e6efff;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .tip {
    background: #fff7ee;
    padding: 10px;
    color: #eba648;
    font-size: 15px;
  }
}
.pageBox {
  padding-top: 20px;
  float: right;
}
.error {
  color: #f56c6c;
  &:focus,
  &:hover {
    color: #f78989;
  }
}
</style>
